const ExpirationTooltip = () => (
    <div className="tooltip-content-wrapper">
        <h2>Test Submissions Expire</h2>
        <p>
            If a test submission has not been modified for a period of 6 months it will automatically be deleted from
            Data Broker.
        </p>
    </div>
);

export default ExpirationTooltip;
